import { gql } from '@apollo/client'

export const GET_EMPLOYEE_PERMISSIONS = gql`
  query GetEmployeePermissions($employeeId: String!) {
    employeePermissions(employeeId: $employeeId) {
      employeePermissionId
      permissionKey
      revokedAt
      permission {
        key
        description
        category
        permissionType
      }
    }
  }
`

export const GET_ALL_PERMISSIONS = gql`
  query GetAllPermissions {
    permissions {
      key
      description
      category
      permissionType
    }
  }
`

export const GRANT_PERMISSION = gql`
  mutation GrantPermission($input: GrantPermissionInput!) {
    grantPermission(input: $input) {
      employeePermissionId
      permissionKey
      grantedAt
    }
  }
`

export const REVOKE_PERMISSION = gql`
  mutation RevokePermission($input: RevokePermissionInput!) {
    revokePermission(input: $input) {
      employeePermissionId
      revokedAt
    }
  }
`

export const BULK_GRANT_PERMISSION = gql`
  mutation BulkGrantPermission($input: BulkPermissionInput!) {
    bulkGrantPermission(input: $input) {
      results {
        employeeId
        success
        skipped
        errorMsg
      }
    }
  }
`

export const BULK_REVOKE_PERMISSION = gql`
  mutation BulkRevokePermission($input: BulkPermissionInput!) {
    bulkRevokePermission(input: $input) {
      results {
        employeeId
        success
        skipped
        errorMsg
      }
    }
  }
`

export const GET_PERMISSION_AUDIT_LOG = gql`
  query GetPermissionAuditLog($employeeId: String!) {
    permissionAuditLog(employeeId: $employeeId) {
      auditLogId
      permissionKey
      action
      actorName
      createdAt
    }
  }
`
